<template>
    <a-modal
        :visible="true"
        :width="700"
        :footer="null"
        :closable="false"
        :destroy-on-close="true"
        centered
        wrap-class-name="tpm-wrap"
        @cancel="$emit('close')"
    >
        <div class="tpm-modal">
            <div class="tpm-head">
                <div>
                    <h3>Adicionar fornecedor</h3>
                    <div class="tpm-sub">Fornecedores disponíveis para esta cotação</div>
                </div>
                <a-tooltip title="Fechar">
                    <a-button class="tpm-x" @click="$emit('close')">
                        <span class="material-icons-outlined">close</span>
                    </a-button>
                </a-tooltip>
            </div>

            <div class="apm-tools">
                <a-input
                    v-model="search"
                    placeholder="Buscar por fornecedor ou vendedor"
                    allow-clear
                    class="apm-search-input"
                >
                    <a-icon slot="prefix" type="search" />
                </a-input>
            </div>

            <div class="tpm-body">
                <a-table
                    size="small"
                    :columns="columns"
                    :data-source="rows"
                    :loading="loading"
                    :pagination="{ pageSize: 20 }"
                    row-key="usu_id"
                    :locale="{ emptyText: 'Nenhum fornecedor disponível.' }"
                >
                    <template slot="fornecedor" slot-scope="text, seller">
                        <div class="tpm-pname">{{ seller.for_nome }}</div>
                    </template>

                    <template slot="vendedor" slot-scope="text, seller">{{ seller.usu_nome }}</template>

                    <template slot="acoes" slot-scope="text, seller">
                        <a-button class="tpm-btn" @click="select(seller)">Adicionar</a-button>
                    </template>
                </a-table>
            </div>

            <div class="tpm-foot">
                <a-button class="tpm-btn-ghost" @click="$emit('close')">Fechar</a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import RequestsService from "@/services/v2/requests.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";

export default {
    name: "AddFornecedorPickerModal",
    props: {
        id: [String, Number],
        excludeIds: { type: Array, default: () => [] },
    },
    data() {
        return {
            svc: new RequestsService(),
            sellers: [],
            loading: false,
            search: "",
        };
    },
    computed: {
        columns() {
            return [
                { title: "Fornecedor", key: "fornecedor", scopedSlots: { customRender: "fornecedor" } },
                { title: "Vendedor", key: "vendedor", scopedSlots: { customRender: "vendedor" } },
                { title: "Ações", key: "acoes", width: 120, align: "center", scopedSlots: { customRender: "acoes" } },
            ];
        },
        rows() {
            const excluded = this.excludeIds.map(String);
            const term = this.search.trim().toLowerCase();

            return this.sellers
                .filter((seller) => !excluded.includes(String(seller.usu_id)))
                .filter(
                    (seller) =>
                        !term ||
                        (seller.for_nome || "").toLowerCase().includes(term) ||
                        (seller.usu_nome || "").toLowerCase().includes(term)
                );
        },
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            this.loading = true;

            this.svc
                .sellers_out(this.id)
                .then((response) => response.data)
                .then((data) => {
                    this.sellers = data;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        select(seller) {
            this.$emit("select", seller);
        },
    },
};
</script>

<style lang="scss" scoped>
.tpm-modal {
    max-height: 88vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.tpm-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 18px 20px 14px;

    h3 {
        font-size: 16px;
        font-weight: 600;
        color: #262626;
    }
}
.tpm-sub {
    font-size: 13px;
    color: #8c8c8c;
    margin-top: 2px;
}
.tpm-x.ant-btn,
.tpm-x.ant-btn:focus,
.tpm-x.ant-btn:active {
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    background: none;
    border-radius: 6px;
    color: #8c8c8c;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center;
}
.tpm-x.ant-btn:hover {
    background: #f0f0f0;
    color: #262626;
}
.apm-tools {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 0 20px 12px;
}
.apm-search-input {
    flex: 1 1 240px;
    max-width: 360px;
}
.tpm-body {
    flex: 1;
    overflow-y: auto;
    padding: 4px 20px;
    border-top: 1px solid #f0f0f0;
    min-height: 200px;
}
.tpm-pname {
    font-weight: 600;
    font-size: 13px;
    color: #262626;
}
.tpm-btn.ant-btn,
.tpm-btn.ant-btn:hover,
.tpm-btn.ant-btn:focus,
.tpm-btn.ant-btn:active {
    height: 28px;
    padding: 0 12px;
    border: 1px solid var(--primary-color);
    background: var(--primary-color-opacity, rgba(232, 96, 44, 0.08));
    color: var(--primary-color);
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    box-shadow: none;
}
.tpm-foot {
    display: flex;
    justify-content: flex-end;
    padding: 14px 20px;
    border-top: 1px solid #f0f0f0;
}
.tpm-btn-ghost.ant-btn,
.tpm-btn-ghost.ant-btn:focus,
.tpm-btn-ghost.ant-btn:active {
    height: 38px;
    padding: 0 18px;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #434343;
    font-weight: 500;
    font-size: 14px;
    box-shadow: none;
}
.tpm-btn-ghost.ant-btn:hover {
    border-color: var(--primary-color);
    color: var(--primary-color);
}
</style>
